<template>
  <v-btn-toggle v-model="value" class="custom-toggle-btn" mandatory>
    <slot></slot>
  </v-btn-toggle>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: ''
    }
  },
  computed: {
    toggleValue: {
      get() {
        return this.value
      },
      set(val) {
        this.value = val
      }
    }
  },
  mounted() {
    this.toggleValue = this.modelValue
  },
  watch: {
    modelValue() {
      this.toggleValue = this.modelValue
    },
    toggleValue(newValue, oldValue) {
      if (oldValue != '') {
        this.$emit('toggleValueChange', newValue)
      }
    }
  }
}
</script>

<style>
.custom-toggle-btn.v-btn-toggle {
  background: none !important;
}

.custom-toggle-btn.v-btn-toggle .v-btn:first-child {
  border-radius: 4px 0 0 4px !important;
}


.custom-toggle-btn.v-btn-toggle .v-btn:last-child {
  border-radius: 0 4px 4px 0 !important;
}

.custom-toggle-btn.v-btn-toggle .v-btn:not(:last-child) {
  border-right: 1px solid transparent;
  border-right-width: 1px;
  border-right-style: solid;
  border-right-color: transparent;
}

.theme--dark.custom-toggle-btn.v-btn-toggle .v-btn {
  text-transform: none;
  padding: 0 16px;
  height: 32px;
  opacity: unset;
}

.theme--light.custom-toggle-btn.v-btn-toggle .v-btn {
  color: #000;
  background: #E4EFE7 !important;
  border: 1.4px solid rgba(69, 90, 100, 1);
}

.custom-toggle-btn.v-btn-toggle .v-btn {
  color: rgba(255, 255, 255, 0.5);
  background: rgba(54, 69, 118, 1) !important;
  border: 1.4px solid rgba(69, 90, 100, 1);
}

.theme--dark.custom-toggle-btn.v-btn-toggle .v-btn.v-btn--active {
  color: #818FFF;
  background: #000 !important;
  border: 1px solid #818FFF;
  z-index: 1;
}

.theme--light.custom-toggle-btn.v-btn-toggle .v-btn.v-btn--active {
  color: #818FFF;
  background: #fff !important;
  border: 1px solid #4a5ef6;
  z-index: 1;
}

</style>